import { distanceIntervaled } from "./common/intervaled.js";
import { weather as weatherAt } from "../api/api.js";

const MINIMUM_DISTANCE_INTERVAL_METERS = 50000;

const weather = distanceIntervaled(
	MINIMUM_DISTANCE_INTERVAL_METERS,

	([$journey], set) => {
		if (!$journey.location) {
			return;
		}

		weatherAt($journey.location)
			.then(({ weather }) => {
				set(weather);
			})
			.catch((error) => {
				console.warn("failed to fetch weather", error.message);
			});
	}
);

export default weather;
